import React from 'react';
import { Col, Row } from 'antd';
import { TagsGroupBoxProps } from './TagsGroupBox.types';
import { TagsContainer } from './TagsGroupBox.styles';
import { BlueTitle } from '../../../styles/common.styles';

const TagsGroupBox: React.FC<TagsGroupBoxProps> = ({ title = "", children }) => (
    <TagsContainer>
        {title && <Row>
            <Col span={24}>
                <BlueTitle>{title}</BlueTitle>
            </Col>
        </Row>}
        <Row>
            <Col span={24}>{children}</Col>
        </Row>
    </TagsContainer>
);

export default TagsGroupBox;